import { animate, style, transition, trigger } from "@angular/animations";
import { OverlayRef } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import {
  Component,
  Inject,
  InjectionToken
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ProductType } from "../../video-generator-form-v2/models/video-form-config";
import { BasketItem } from "../models/basketItem.model";
import { BasketItemsService } from "../services/basketItems.service";


export const BASKET_MODAL_REF = new InjectionToken<OverlayRef>(
  "BASKET_MODAL_REF"
);

@Component({
  selector: 'app-basket-popup',
  standalone: true,
  templateUrl: "./basket-popup.component.html",
  styleUrls: ["./basket-popup.component.scss"],
  imports: [
    CommonModule,
    FontAwesomeModule,
    RouterLink,
    TranslateModule,
  ],
  animations: [
    trigger("openCloseBasket", [

      transition(":enter", [
        style({ transform: "translateX(100%)" }),
        animate("250ms ease-in-out", style({ transform: "translateX(0)" })),
      ]),
      transition(":leave", [
        style({ transform: "translateX(0%)" }),
        animate("250ms ease-in-out", style({ transform: "translateX(100%)" })),
      ]),
    ]),
  ],
})
export class BasketPopupComponent {
  basketTotal: number;
  iconX = faX;
  iconTrash = faTrashCan;
  productType = ProductType;
  basketItems: BasketItem[] = [];


  constructor(
    @Inject(BASKET_MODAL_REF) public overlayRef: OverlayRef,
    private basketItemsService: BasketItemsService,
    private readonly translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.initItems();
  }

  initItems() {
    this.basketItems = this.basketItemsService.items;
    this.calculateBasketTotal();
  }

  calculateBasketTotal() {
    this.basketTotal = this.basketItems.reduce(
      (sum, project) => sum + project.price,
      0
    );
  }

  closePopup() {
    this.overlayRef.dispose();
  }

  removeItem(item: any) {
    if (!confirm(this.translate.instant('basket.confirms.removeItem'))) {
      return;
    }
    this.basketItemsService.remove(item);
    this.initItems();
  }

  isBasketEmpty() {
    return this.basketItemsService.isBasketEmpty();
  }
}
